/**
 * @generated SignedSource<<8285eabee7886dd301a394a04c0a01f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type ProductSkuOfferDeliveryChannel = "DELIVERY" | "PICKUP_IN_POINT" | "TAKE_AWAY";
import { FragmentRefs } from "relay-runtime";
export type productSkuOfferConnection_ProductSkuOfferConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly seller: {
        readonly _id: string;
      };
      readonly deliveryChannel: ProductSkuOfferDeliveryChannel;
      readonly listPrice: {
        readonly amount: number;
      };
      readonly netPrice: {
        readonly amount: number;
      };
      readonly priority: number;
    };
  }>;
  readonly " $fragmentType": "productSkuOfferConnection_ProductSkuOfferConnection";
};
export type productSkuOfferConnection_ProductSkuOfferConnection$key = {
  readonly " $data"?: productSkuOfferConnection_ProductSkuOfferConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"productSkuOfferConnection_ProductSkuOfferConnection">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "productSkuOfferConnection_ProductSkuOfferConnection"
};

(node as any).hash = "bd0196ebdd0f5a70f60e334922dce3ea";

export default node;
